<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h3 class="card-title">Zonas</h3>
            <div>
              <input type="file" ref="fileInput" @change="handleFileUpload" style="display: none" accept=".xlsx, .xls"/>
              <button class="btn btn-primary mr-2" @click="$refs.fileInput.click()">Importar</button>
              <button class="btn btn-success" @click="openDialog()">Crear Zona</button>
            </div>
          </div>
          <div class="card-body">
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Descripción</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="zona in zonas" :key="zona.co_zon">
                  <td>{{ zona.co_zon.trim() }}</td>
                  <td>{{ zona.zon_des.trim() }}</td>
                  <td>
                    <button class="btn btn-sm btn-warning mr-2" @click="openDialog(zona)">Editar</button>
                    <button class="btn btn-sm btn-danger" @click="deleteZona(zona._id)">Eliminar</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Dialog for Create/Edit -->
    <div class="modal" tabindex="-1" role="dialog" :style="{ display: dialog ? 'block' : 'none' }">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ form._id ? 'Editar' : 'Crear' }} Zona</h5>
            <button type="button" class="close" @click="closeDialog">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Código</label>
              <input type="text" class="form-control" v-model="form.co_zon">
            </div>
            <div class="form-group">
              <label>Descripción</label>
              <input type="text" class="form-control" v-model="form.zon_des">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeDialog">Cancelar</button>
            <button type="button" class="btn btn-primary" @click="saveZona">Guardar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import zonaService from "../services/zonaService";
import * as XLSX from 'xlsx';

export default {
  name: "Zonas",
  data() {
    return {
      zonas: [],
      dialog: false,
      form: {
        _id: null,
        co_zon: '',
        zon_des: '',
      },
    };
  },
  methods: {
    async loadZonas() {
      this.zonas = await zonaService.getZonas();
    },
    openDialog(zona = null) {
      if (zona) {
        this.form = { ...zona };
      } else {
        this.form = { _id: null, co_zon: '', zon_des: '' };
      }
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    async saveZona() {
      if (this.form._id) {
        await zonaService.updateZona(this.form);
      } else {
        await zonaService.createZona(this.form);
      }
      this.loadZonas();
      this.closeDialog();
    },
    async deleteZona(id) {
      if (confirm('¿Estás seguro de que quieres eliminar esta zona?')) {
        await zonaService.deleteZona(id);
        this.loadZonas();
      }
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = async (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 'A' });

        const zonasAImportar = jsonData.slice(1).map(row => ({
          co_zon: row['A'] ? String(row['A']).trim() : '',
          zon_des: row['B'] ? String(row['B']).trim() : '',
        }));

        const response = await zonaService.importZonas(zonasAImportar);
        alert(response.message);
        this.loadZonas();
        this.$refs.fileInput.value = '';
      };
      reader.readAsArrayBuffer(file);
    }
  },
  created() {
    this.loadZonas();
  },
};
</script>
